import React from "react";
import {observer} from "mobx-react";
import {MoreDetailsContainerBox} from "./boxes/end-section/more-details/more-details-container.box";

import {MoreDetailsLeftCornerBox} from "./boxes/end-section/more-details/more-details-left-corner.box";
import {NullableString} from "../../../../../common/types/nullable-types";
import {MoreDetailsTextBox} from "./boxes/end-section/more-details/more-details-text.box";
import {MoreDetailsArrowBox} from "./boxes/end-section/more-details/more-details-arrow.box";
import {ForwardArrowBox} from "../../../../basic-components/right-arrow/forward-arrow.box";

interface HistoryMoreDetailsButtonComponentProps {
    className?: string;
    onClick: () => void;
    isClickable: boolean;
    notAllowedMessage?: NullableString;
    buttonText: string;
}
export const HistoryMoreDetailsButtonComponent: React.FC<HistoryMoreDetailsButtonComponentProps> = observer((props) => {

    const _renderMoreDetailsButtonContent = () => {
        if (props.notAllowedMessage) {
            return (
                <MoreDetailsTextBox>
                    {props.notAllowedMessage}
                </MoreDetailsTextBox>
            );
        }

        return (
            <>
                <MoreDetailsTextBox>
                    {props.buttonText}
                </MoreDetailsTextBox>
                <MoreDetailsArrowBox>
                    <ForwardArrowBox/>
                </MoreDetailsArrowBox>
            </>
        );
    }

    return (
        <MoreDetailsContainerBox className={props.className}
                                 onClick={props.onClick}
                                 isClickable={props.isClickable}>
            <MoreDetailsLeftCornerBox/>
            {_renderMoreDetailsButtonContent()}
        </MoreDetailsContainerBox>
    );
})